import Dashboard from './Dashboard'; 
import Contract from './Contract';
import Operation from './Operation';
import Other from './Other';
import Transfer from './Transfer';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [ Dashboard, Transfer, Contract, Operation, Other]
};

export default menuItems;
